module.exports = __webpack_public_path__ + "img/Microsoft_AZ-220.6edf1a71.png";